import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";

import { SpaceDetailsContext } from "../types";

const SpaceDetailsContextsInheritedFromCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsContext>) => (
  <TableSimpleCell {...cellProps}>
    {context.inheritedFrom ? (
      <SpacePath spaceId={context.inheritedFrom.id} fallbackName={context.inheritedFrom.name} />
    ) : (
      <TableCellEmpty />
    )}
  </TableSimpleCell>
);

export default SpaceDetailsContextsInheritedFromCell;
